export const galleryPath = '/gallery'
export const galleryUrl = `https://museum.belegends.com${galleryPath}`

const museumInternalPathPattern = /^\/(auth|cards|dashboard|faq|gallery|my-collection|organizers|profile|trophies)(\/|$)/

export function toInternalMuseumHref (href: string): string {
  if (href.trim() === '') {
    return href
  }

  if (href.startsWith('/')) {
    return href
  }

  try {
    const url = new URL(href)
    const normalizedPath = `${url.pathname}${url.search}${url.hash}`

    if (museumInternalPathPattern.test(url.pathname)) {
      return normalizedPath
    }
  } catch (_error) {
    return href
  }

  return href
}
